import React from "react";
import { Link } from "react-router-dom";

const Categories = (props) => {
    // if (props.user.username === 'hugh.admin' || props.user.username === 'utdemo') {}

    return (
        <div className="categories-container">
            <div className="categories-row">
                <div className="category">
                    <Link
                        to="/utp"
                        onClick={props.setPlatformType.bind(this, "utp")}
                    >
                        <div className="image utp-140524"></div>
                    </Link>
                    <div className="title">
                        <div className="name">UT Physicians</div>
                        <div className="button-container">
                            <Link
                                to="/utp"
                                onClick={props.setPlatformType.bind(
                                    this,
                                    "utp"
                                )}
                            >
                                <button>Select</button>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link
                        to="/uth"
                        onClick={props.setPlatformType.bind(this, "uth")}
                    >
                        <div className="image uth"></div>
                    </Link>
                    <div className="title">
                        <div className="name">UTHealth Houston</div>
                        <div className="button-container">
                            <Link
                                to="/uth"
                                onClick={props.setPlatformType.bind(
                                    this,
                                    "uth"
                                )}
                            >
                                <button>Select</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Categories;
